import type { ReactNode } from 'react'
import React, { memo } from 'react'

import { type Color, ColorItem } from '@fourthwall/components'

import type { VariantItem } from '../../SelectProductsModal.types'
import { OpacityWrapper, ProductInfo } from '../ProductsListItem/ProductsListItem.styled'
import * as S from './ProductsListItemVariantContent.styled'

type VariantItemContentProps = {
  item: VariantItem
  input: ReactNode
}

export const ProductsListItemVariantContent = memo(({ item, input }: VariantItemContentProps) => (
  <>
    <S.Indent />
    <OpacityWrapper>{input}</OpacityWrapper>
    <ProductInfo>
      <OpacityWrapper>
        <S.EnhancedItemName>
          {item.color && <ColorItem size="small" color={item.color as Color} />}
          {item.name}
        </S.EnhancedItemName>
      </OpacityWrapper>
    </ProductInfo>
  </>
))
